/**
 * Simple Plans
 *
 * @author      Anoopkumar
 * @copyright   2023 Simple Plans
 * @license     -
 *
 **/

import { combineReducers } from "redux";

import { resources } from "./resources";

const reducers = combineReducers({
  resources,
});

export default reducers;
